import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { accountPaymentProcessors } from "@circle-react/helpers/urlHelpers/internalApi/accountPaymentProcessors";
import { UPGRADE_PATHS } from "../constants";

interface CheckoutSessionParams {
  coupon_id?: number;
  plan_id: number;
  source: string;
}

export const useAccountPaymentProcessorsApi = () => {
  const history = useHistory();

  const { mutate: createCheckoutSession } = useMutation(
    ({ plan_id, coupon_id, source }: CheckoutSessionParams) =>
      reactQueryPost(accountPaymentProcessors.checkoutSession.create(), {
        plan_id,
        coupon_id: coupon_id,
        source,
      }),
    {
      onSuccess: (data: any) => {
        window.location.href = data.url;
      },
      onError: () => {
        history.push(UPGRADE_PATHS.ERROR);
      },
    },
  );

  return {
    createCheckoutSession,
  };
};
